// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/img/Landing-page-background-image-.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body{
    font-family:Lato,'Helvetica Neue',Helvetica,Arial,sans-serif}
    
h1,h2,h3,h4,h5,h6{
    font-family:Lato,'Helvetica Neue',Helvetica,Arial,sans-serif;font-weight:700
}

header.masthead{
    position:relative;
    background-color:#343a40;
    background:url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center center;
    background-size:cover;padding-top:6rem;padding-bottom:6rem}

header.masthead .overlay{
    position:absolute;background-color:#212529;height:100%;width:100%;top:0;left:0;opacity:.3}
    
header.masthead h1{
    font-size:2rem
}

header.masthead h3{
    font-size: 24px; 
    padding-top: 40px
}


@media (min-width:768px){
    header.masthead{padding-top: 12rem;
        padding-bottom: 10rem;}
    header.masthead h1{font-size:3rem}
    .welcome-text{
        padding: 2% 12% 1%!important;
    }

    .issues-text {
        padding: 2% 12% 0 !important;
    }

    .main-card{
        width: 50% !important;
    }
}

.showcase .showcase-text{padding:3rem}
.showcase .showcase-img{min-height:30rem;background-size:cover}

@media (min-width:768px){
    .showcase .showcase-text{padding:7rem}
}

.features-icons{padding-top:1.5rem;padding-bottom:1rem;}

footer .container{
    padding: 4rem 0;
    background-color: #f8f9fa;
}
footer.footer .footer-text{
    font-size: 12px; font-weight: 600; padding-bottom: 10px;
}
footer ul{
    font-size: 12px;
}

footer .copyright-txt{
    font-size: 12px;
}


.main-card{
    background: #F8F9FA;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25), 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 2px;
    padding: 2%;
    width: 90%;
    color: #144B7B;
}

.card-center{
    place-content: center;
}

.welcome-text{
    padding: 0;
}

.issues-text{
    padding: 2% 0 0;
    
}

.issues-text a, .thankyoufooter a{
    cursor: pointer;
    text-decoration: underline;
    color: #000;
}

input{
    background: rgba(229, 229, 229, 0.39);
    box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.25);
}

.submit-btn{
    background: #D52B1E;
    border-color: #d52b1e;
    box-shadow: 0px 4px 2px rgba(0, 0, 0, 0.25);
    border-radius: 5px;
    color: #fff;
    height: 2rem;
}

.submit-btn:hover{
    background: #D52B1E;
    border-color: #d52b1e;
    box-shadow: 0px 4px 2px rgba(0, 0, 0, 0.25);
    border-radius: 5px;
    color: #fff;
    font-weight: bold;
}

.tnc{
    text-decoration: underline;
    font-weight: bold;
    color: #144B7B;
}

.mandate_field{
    font-weight: bold;
    font-size: 125%;
    color: #d52b1e;
}

.error{
    color: #d52b1e;
    font-size: 14px;
}

#Termsandcondition{
    margin-top: 0.7rem;
}

.form-check-input-reverse{
    margin-left: 10px !important;
}

.form-check-padding{
    padding-left: 0 !important;
}

.thankyoufooter{
    font-style: italic;
    margin-top: 5%;
    color: #000;
}

datalist {
    display: none;
  }
`, "",{"version":3,"sources":["webpack://./src/client/css/style.css"],"names":[],"mappings":"AAAA;IACI,4DAA4D;;AAEhE;IACI,4DAA4D,CAAC;AACjE;;AAEA;IACI,iBAAiB;IACjB,wBAAwB;IACxB,0EAAwF;IACxF,qBAAqB,CAAC,gBAAgB,CAAC,mBAAmB;;AAE9D;IACI,iBAAiB,CAAC,wBAAwB,CAAC,WAAW,CAAC,UAAU,CAAC,KAAK,CAAC,MAAM,CAAC,UAAU;;AAE7F;IACI;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;;AAGA;IACI,gBAAgB,kBAAkB;QAC9B,qBAAqB,CAAC;IAC1B,mBAAmB,cAAc;IACjC;QACI,4BAA4B;IAChC;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,qBAAqB;IACzB;AACJ;;AAEA,yBAAyB,YAAY;AACrC,wBAAwB,gBAAgB,CAAC,qBAAqB;;AAE9D;IACI,yBAAyB,YAAY;AACzC;;AAEA,gBAAgB,kBAAkB,CAAC,mBAAmB,CAAC;;AAEvD;IACI,eAAe;IACf,yBAAyB;AAC7B;AACA;IACI,eAAe,EAAE,gBAAgB,EAAE,oBAAoB;AAC3D;AACA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;;AAGA;IACI,mBAAmB;IACnB,4EAA4E;IAC5E,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,eAAe;;AAEnB;;AAEA;IACI,eAAe;IACf,0BAA0B;IAC1B,WAAW;AACf;;AAEA;IACI,qCAAqC;IACrC,iDAAiD;AACrD;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,2CAA2C;IAC3C,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,2CAA2C;IAC3C,kBAAkB;IAClB,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,0BAA0B;IAC1B,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,WAAW;AACf;;AAEA;IACI,aAAa;EACf","sourcesContent":["body{\n    font-family:Lato,'Helvetica Neue',Helvetica,Arial,sans-serif}\n    \nh1,h2,h3,h4,h5,h6{\n    font-family:Lato,'Helvetica Neue',Helvetica,Arial,sans-serif;font-weight:700\n}\n\nheader.masthead{\n    position:relative;\n    background-color:#343a40;\n    background:url(\"/public/img/Landing-page-background-image-.png\") no-repeat center center;\n    background-size:cover;padding-top:6rem;padding-bottom:6rem}\n\nheader.masthead .overlay{\n    position:absolute;background-color:#212529;height:100%;width:100%;top:0;left:0;opacity:.3}\n    \nheader.masthead h1{\n    font-size:2rem\n}\n\nheader.masthead h3{\n    font-size: 24px; \n    padding-top: 40px\n}\n\n\n@media (min-width:768px){\n    header.masthead{padding-top: 12rem;\n        padding-bottom: 10rem;}\n    header.masthead h1{font-size:3rem}\n    .welcome-text{\n        padding: 2% 12% 1%!important;\n    }\n\n    .issues-text {\n        padding: 2% 12% 0 !important;\n    }\n\n    .main-card{\n        width: 50% !important;\n    }\n}\n\n.showcase .showcase-text{padding:3rem}\n.showcase .showcase-img{min-height:30rem;background-size:cover}\n\n@media (min-width:768px){\n    .showcase .showcase-text{padding:7rem}\n}\n\n.features-icons{padding-top:1.5rem;padding-bottom:1rem;}\n\nfooter .container{\n    padding: 4rem 0;\n    background-color: #f8f9fa;\n}\nfooter.footer .footer-text{\n    font-size: 12px; font-weight: 600; padding-bottom: 10px;\n}\nfooter ul{\n    font-size: 12px;\n}\n\nfooter .copyright-txt{\n    font-size: 12px;\n}\n\n\n.main-card{\n    background: #F8F9FA;\n    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25), 0px 4px 4px rgba(0, 0, 0, 0.25);\n    border-radius: 2px;\n    padding: 2%;\n    width: 90%;\n    color: #144B7B;\n}\n\n.card-center{\n    place-content: center;\n}\n\n.welcome-text{\n    padding: 0;\n}\n\n.issues-text{\n    padding: 2% 0 0;\n    \n}\n\n.issues-text a, .thankyoufooter a{\n    cursor: pointer;\n    text-decoration: underline;\n    color: #000;\n}\n\ninput{\n    background: rgba(229, 229, 229, 0.39);\n    box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.25);\n}\n\n.submit-btn{\n    background: #D52B1E;\n    border-color: #d52b1e;\n    box-shadow: 0px 4px 2px rgba(0, 0, 0, 0.25);\n    border-radius: 5px;\n    color: #fff;\n    height: 2rem;\n}\n\n.submit-btn:hover{\n    background: #D52B1E;\n    border-color: #d52b1e;\n    box-shadow: 0px 4px 2px rgba(0, 0, 0, 0.25);\n    border-radius: 5px;\n    color: #fff;\n    font-weight: bold;\n}\n\n.tnc{\n    text-decoration: underline;\n    font-weight: bold;\n    color: #144B7B;\n}\n\n.mandate_field{\n    font-weight: bold;\n    font-size: 125%;\n    color: #d52b1e;\n}\n\n.error{\n    color: #d52b1e;\n    font-size: 14px;\n}\n\n#Termsandcondition{\n    margin-top: 0.7rem;\n}\n\n.form-check-input-reverse{\n    margin-left: 10px !important;\n}\n\n.form-check-padding{\n    padding-left: 0 !important;\n}\n\n.thankyoufooter{\n    font-style: italic;\n    margin-top: 5%;\n    color: #000;\n}\n\ndatalist {\n    display: none;\n  }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
